module.exports = __webpack_public_path__ + "static/media/Ross Perot - 1996.f4edf544.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/Ross Perot - 1996.jpg
// module id = 544
// module chunks = 0